import * as React from 'react';
import ErrorIcon from '@material-ui/icons/Error';

import * as styles from './announcement.module.scss';

interface Props {
  message: string;
}

/**
 * @function PriorityTwoFailure - Component for failure messages
 */
const PriorityTwoFailure = ({ message }: Props) => {
  return (
    <div className={styles.priorityTwoFailure}>
      <ErrorIcon />
      <span>{message}</span>
    </div>
  );
};

export default PriorityTwoFailure;
